import styled from "styled-components";

import backgroundImage from "../../assets/ademars/4_thank_you/Rock_Texture.png";
import theme from "../../modules/themes";
// import overlay from "../../assets/images/Overlay@2x.png";

export const Wrapper = styled.section`
  min-height: ${window.innerHeight}px;
  font-family: alternate_gothic_bold;
  text-align:center;
  background-color:black;

`;

export const BackgroundImage = styled.div`
  height: ${window.innerHeight}px;
  background-image: url(${backgroundImage});
  background-size: cover;
  background-position: center;
  background-color:black;
  opacity: 1;
  position:relative;

  .main-logo{
    padding-top: 3.5rem;
    width:60%;
  }
`

export const Container = styled.section`
  width: 100%;
  margin: auto;
`;

export const SecondaryTitle = styled.h1`
  font-family: helvetica-neue-extra-light;
  margin: 0 auto;
  font-size: 46px;
  color: #ffffff;
  text-transform: uppercase;
  padding:0;
  line-height:1;
  font-weight:200;

  @media(max-width:460px){
    font-size: 32px;
  }

  @media(max-width:375px){
    font-size: 28px;
  }

  @media(max-width:330px){
    font-size: 26px;
  }
  
`;

export const GoodByeMessage = styled.div`
  position: absolute;
  bottom: 20%;
  left: 50%;
  transform: translateX(-50%);
  width:100%;

  div{
    text-align: center
  }
`
